<template>
  <div>
    <div v-if="showSlideOrImage" class="relative isolate">
      <Swiper
        :modules="[SwiperNavigation, SwiperAutoplay, SwiperEffectFade]"
        :loop="enableLoopSlide"
        :centered-slides="true"
        effect="'fade'"
        :slides-per-view="1"
        :navigation="{
          nextEl: `.swiper-button-costume-next`,
          prevEl: `.swiper-button-costume-prev`
        }"
        class="relative"
      >
        <template v-for="(image, index) in props.images" :key="index + 'cf'">
          <SwiperSlide>
            <NuxtImg
              :src="`${image}`"
              class="w-full md:!w-full md:h-96 h-64 object-cover"
              alt="activity slide"
              format="webp"
            />
          </SwiperSlide>
        </template>

        <div
          role="button"
          v-if="enableLoopSlide"
          aria-label="Previous slide"
          class="swiper-button-costume-next md:top-[170px] top-[72px] absolute z-10 left-2 border border-white rounded-full md:h-14 md:w-14 h-8 w-8 hover:bg-white/50 flex items-center justify-center text-white"
        >
          <Icon name="i-heroicons-arrow-left" class="h-6 w-6 stroke-2" />
        </div>

        <div
          role="button"
          v-if="enableLoopSlide"
          aria-label="Next Slide"
          class="swiper-button-costume-prev md:top-[170px] top-[72px] z-10 absolute right-2 border border-white rounded-full md:h-14 md:w-14 h-8 w-8 hover:bg-white/50 flex items-center justify-center text-white"
        >
          <Icon name="i-heroicons-arrow-right" class="h-6 w-6 stroke-2" />
        </div>
      </Swiper>
    </div>
    <div v-else class="relative">
      <img
        src="https://fakeimg.pl/400x400?text=activity"
        class="w-full md:!w-[320px] !h-[320px] object-cover"
        loading="lazy"
        alt="activity slide"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  images: {
    type: Array as PropType<string[]>
  }
})

const enableLoopSlide = computed(() => {
  return props.images ? props.images.length > 1 : false
})

const showSlideOrImage = computed(() => {
  return !!props.images?.length
})
</script>

<style scoped></style>
